import notify from 'devextreme/ui/notify';
import store from '../store'
import {
    request
} from '../request/axios.request';
import {
    errorCommon
} from './error.common'

function login(email, password) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/IdentityProviderApi/Login',
        method: 'post',
        data: {
            "PhoneNumber": "",
            "Email": email,
            "Password": password
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("Login Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function changePassword(currentPassword, newPassword) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/IdentityProviderApi/ChangePassword',
        method: 'post',
        data: {
            "CurrentPassword": currentPassword,
            "NewPassword": newPassword
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ChangePassword Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function forgotPassword(mailAddress) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/IdentityProviderApi/ForgotPassword',
        method: 'post',
        data: {
            "MailAddress": mailAddress,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ForgotPassword Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function resetPassword(mailAddress, token, newPassword) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/IdentityProviderApi/ResetPassword',
        method: 'post',
        data: {
            "MailAddress": mailAddress,
            "Token": token,
            "NewPassword": newPassword,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ResetPassword Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getMenus() {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/ResourceProviderApi/GetMenus',
        method: 'get',
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetMenus Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function selectLocation(workerId) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_AUTH,
        responseType: 'json',
        url: '/api/v2/IdentityProviderApi/SelectLocation',
        method: 'post',
        data: workerId,
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("SelectLocation Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function handleRequest(config) {
    let url = config.url;

    if (url.indexOf("Login") == -1) {
        config.headers.Authorization = 'Bearer ' + store.state.token;
    }

    return config;
}

function handleResponse() {
}

export const authService = {
    login,
    changePassword,
    forgotPassword,
    resetPassword,
    getMenus,
    selectLocation,
};